import Form, { formCreate } from '../../../../../components/form';
import request from '../../../../../utils/request';
import Supplys from './components/supplys';
import terminalContactInfo from './components/contact_info/contact_info.vue';

formCreate.component('Supplys', Supplys);
formCreate.component('terminalContactInfo', terminalContactInfo);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'terminal_audit_form',
      formParentCode: 'CRM20211102000002755',
      rule: [],
      mdmCustomerContactVos: [
        {
          contactMain: '',
          contactName: '',
          contactPhone: '',
          id: new Date().getTime(),
        },
      ],
      supplys: [
        {
          supplyType: '', // 供货关系类型
          positionCode: '', // 负责人
          orgCode: '', // 组织
          customerCode: '', // 上级客户
          saleCompany: '', // 销售公司
          channel: '', // 渠道
          details: [],
          userName: '1',
          id: new Date().getTime(),
        },
      ],
      mdmCustomerContactVosItem: {
        contactMain: '',
        contactName: '',
        contactPhone: '',
      },
      supplysItem: {
        supplyType: '', // 供货关系类型
        positionCode: '', // 负责人
        orgCode: '', // 组织
        customerCode: '', // 上级客户
        saleCompany: '', // 销售公司
        channel: '', // 渠道
        userName: '',
        details: [],
      },
      showData: [],
    };
  },
  mounted() {
    this.getTerminalType();
  },
  methods: {
    // 获取
    getTerminalType() {
      request.get('/mdm/mdmdictdata/dictTree', { dictTypeCode: 'sfa_terminal_xi' }).then((res) => {
        if (res.success) {
          this.terminalType = res.result || [];
        }
      });
    },
    init() {
      request.post('/mdm/mdmTerminalExpandController/appletTerminalApproveRecordDetail', {
        id: this.formConfig.row.id,
        formNo: this.formConfig.row.id,
      }).then((res) => {
        if (res.success) {
          const { result } = res;
          this.mdmCustomerContactVos = !result || !result.contacts || result.contacts.length === 0
            ? [
              {
                contactMain: '',
                contactName: '',
                contactPhone: '',
                id: new Date().getTime(),
              },
            ]
            : result.contacts;
          this.supplys = !result || !result.supplys || result.supplys.length === 0
            ? [
              {
                supplyType: '', // 供货关系类型
                positionCode: '', // 负责人
                orgCode: '', // 组织
                customerCode: '', // 上级客户
                saleCompany: '', // 销售公司
                channel: '', // 渠道
                details: [],
                userName: '',
                id: new Date().getTime(),
              },
            ]
            : result.supplys;
          const contacts = this.getRule('contacts');
          const supplys = this.getRule('supplys');
          contacts.props = {
            ...contacts.props,
            contactInfoData: this.mdmCustomerContactVos,
          };
          supplys.props = {
            ...supplys.props,
            extendInfoData: this.supplys,
          };

          if (res.result.ext41) {
            for (const item of this.terminalType) {
              if (item.dictCode === res.result.ext41) { // 找到了大类
                const dataList = item.children || [];
                const tempArr = [];
                dataList.forEach((t) => {
                  tempArr.push({
                    label: t.dictValue,
                    value: t.dictCode,
                  });
                });
                const ext42 = this.getRule('ext42');
                ext42.options = tempArr;
              }
            }
          }
          this.setValue(result);
        }
      });
    },
    formComplete() {
      // 联系人添加按钮
      const title2 = this.getRule('title2');
      const mdmCustomerContactVos = this.getRule('contacts');
      if (this.formConfig.code !== 'view') {
        title2.props.showAdd = true;
      }
      mdmCustomerContactVos.props = {
        ...mdmCustomerContactVos.props,
        contactInfoData: this.mdmCustomerContactVos,
      };
      title2.on = {
        add: () => {
          this.mdmCustomerContactVos.push({
            ...this.mdmCustomerContactVosItem,
            id: new Date().getTime(),
          });
          mdmCustomerContactVos.props = {
            ...mdmCustomerContactVos.props,
            contactInfoData: this.mdmCustomerContactVos,
          };
        },
      };
      mdmCustomerContactVos.on = {
        del: (index) => {
          this.mdmCustomerContactVos.splice(index, 1);
        },
      };

      // 联系人添加按钮
      const title3 = this.getRule('title3');
      const supplys = this.getRule('supplys');
      if (this.formConfig.code !== 'view') {
        title3.props.showAdd = true;
      }
      supplys.props = {
        ...supplys.props,
        extendInfoData: this.supplys,
      };
      title3.on = {
        add: () => {
          this.supplys.push({
            ...this.supplysItem,
            id: new Date().getTime(),
          });
          supplys.props = {
            ...supplys.props,
            extendInfoData: this.supplys,
          };
        },
      };
      supplys.on = {
        del: (index) => {
          this.supplys.splice(index, 1);
        },
      };

      if (this.formConfig.row && this.formConfig.row.id) {
        this.init();
      }
    },

  },
};
